import React from 'react';
import {formatCurrency} from "../../utils/format";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {
    selectPortfolioReserveButtonStates,
    selectPortfolioReserveOptions,
    selectPortfolioReserveUserPreferences,
    setPortfolioReserveButtonStates,
    setPortfolioReserveUserPreferences
} from "./PortfolioReserveSlice";
import {convertDecimalToPercentage} from "../GoalsParsers";
import {Button} from "../../components";
import {useAnalyticsTrackers} from "../../utils/useAnalyticsTrackers";

export type PortfolioRiskProps = {
    cvar: number;
    totalInvestableAssetsMinusCash: number;
    portfolioRiskRowActive?:number | boolean;
    currentPage?: string;
}

const PortfolioRisk: React.FC<PortfolioRiskProps> = ({
                                                         cvar,
                                                         totalInvestableAssetsMinusCash,
                                                         portfolioRiskRowActive,
                                                         currentPage
                                                     }) => {
    const dispatch = useAppDispatch();
    const portfolioReserveUserPreferences = useAppSelector(selectPortfolioReserveUserPreferences);
    const portfolioReserveOptions = useAppSelector(selectPortfolioReserveOptions);

    const portfolioReserveButtonStates = useAppSelector(selectPortfolioReserveButtonStates);
    const {portfolioRisk} = portfolioReserveButtonStates;
    const { track, page} = useAnalyticsTrackers();
    const portfolioRiskClickHandler = () => {
        dispatch(setPortfolioReserveButtonStates({
            ...portfolioReserveButtonStates,
            portfolioRisk: true
        }))

        if(portfolioReserveButtonStates.assetAllocation && portfolioReserveButtonStates.excessAssets){
            dispatch(setPortfolioReserveUserPreferences({
                ...portfolioReserveUserPreferences,
                editablePortfolioReserve: true,
                clickedPortfolioReserveTargetLengthInput: false,
                clickedLifestyleMinimumRiskInput: false
            }));
        }
    };

    const assetAllocationRiskClass =  portfolioReserveOptions.showRiskImpact ? "edit-portfolio-reserve-page__table__portfolio-risk__expanded-risk-row" : "edit-portfolio-reserve-page__table__portfolio-risk__cvar"

    if (portfolioRisk || portfolioRiskRowActive) {
        return (
            portfolioReserveOptions.marketStressTest === "Conditional Value at Risk" ?
            <div
                data-testid="portfolio-risk-display-text"
                aria-label="PortfolioRisk"
                className="edit-portfolio-reserve-page__table__portfolio-risk">
                <div
                    className={assetAllocationRiskClass}>
                    This asset allocation could experience a <span
                    style={{color: cvar < 0 ? '#AC5300' : '#05676E'}}>{convertDecimalToPercentage(cvar, 2).toFixed(2)}%</span> return.
                </div>

                {portfolioReserveOptions.showRiskImpact &&
                    <div className="edit-portfolio-reserve-page__table__portfolio-risk__excess-assets-impact">
                        <div>
                            <span>
                                Impact on Investable Portfolio
                            </span>
                        </div>
                        <div>
                            <span style={{
                                color: cvar < 0 ? '#AC5300' : '#05676E',
                                textAlign: "right"
                            }}>{formatCurrency(cvar * totalInvestableAssetsMinusCash)}
                            </span>
                        </div>
                    </div>
                }
            </div> :
            <div className={"row-inactive"}>
                Select a Historical Market Stress Events
            </div>
        );
    } else {
        return (
            <div
                data-testid="portfolio-risk-plus-button"
                className="edit-portfolio-reserve-page__centered" style={{width: "100%", height: "100%", marginTop: '5%'}}>
                <Button
                    data-testid="portfolio-risk-button"
                    aria-label="PortfolioRiskButton"
                    icon="only"
                    kind="borderless"
                    iconName="add_circle_outline"
                    size="large"
                    type="button"
                    className="edit-portfolio-reserve-page__button"
                    onClick={()=>{portfolioRiskClickHandler();
                        page(`${currentPage}_Click_Risky_Asset_Allocation`);
                        track(`${currentPage}_Click_Risky_Asset_Allocation`);
                    }}
                />
            </div>
        );
    }
}

export default PortfolioRisk;
